import { Link } from "react-router-dom";
import {
    ChartCandlestick,
    Building2,
    ReceiptText,
    Receipt,
    Users,
    FileText,
    Award,
    Scale,
    MessageSquareText,
    ArrowUpRight,
    Sprout,
} from "lucide-react";

const SERVICES = [
    {
        icon: ChartCandlestick,
        title: "Proyectos de inversión ante COMAP",
        desc: "Elaboramos y presentamos tu proyecto para acceder a beneficios fiscales y financiamiento. Desde la idea hasta la aprobación.",
        featured: true,
    },
    {
        icon: Building2,
        title: "Apertura de empresas",
        desc: "Te asesoramos en la forma jurídica más conveniente y gestionamos todos los trámites de constitución.",
    },
    {
        icon: ReceiptText,
        title: "Contabilidad mensual",
        desc: "Registro y seguimiento contable continuo para que siempre tengas información clara sobre tu empresa.",
    },
    {
        icon: Receipt,
        title: "Liquidación de impuestos",
        desc: "Calculamos y presentamos tus obligaciones fiscales ante DGI en tiempo y forma, sin sorpresas.",
    },
    {
        icon: Users,
        title: "Liquidación de sueldos",
        desc: "Gestión de nómina, aportes BPS y obligaciones laborales para que tu equipo esté siempre al día.",
    },
    {
        icon: FileText,
        title: "Declaraciones juradas",
        desc: "Preparación y presentación de declaraciones anuales y periódicas ante los organismos correspondientes.",
    },
    {
        icon: Award,
        title: "Certificaciones contables",
        desc: "Emitimos certificados e informes contables para trámites bancarios, licitaciones y gestiones oficiales.",
    },
    {
        icon: Scale,
        title: "Balances",
        desc: "Elaboración de estados financieros con la información que tu empresa necesita para tomar decisiones.",
    },
    {
        icon: MessageSquareText,
        title: "Asesoramiento integral",
        desc: "Consultoría contable, fiscal y financiera permanente para que cada decisión esté respaldada por información precisa.",
    },
];

export default function Services() {
    return (
        <section
            id="servicios"
            data-testid="services-section"
            className="relative bg-[var(--uma-cream)] py-24 md:py-32"
        >
            <div className="max-w-7xl mx-auto px-5 md:px-10">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end mb-14 md:mb-20">
                    <div className="lg:col-span-7 reveal">
                        <div className="uma-eyebrow left">
                            <span>Qué hacemos</span>
                        </div>
                        <h2 className="font-serif-display text-[36px] md:text-[56px] lg:text-[68px] leading-[1.02] mt-6 text-[var(--uma-forest)]">
                            Nuestros
                            <br />
                            <em className="italic font-light text-[var(--uma-gold)]">
                                servicios.
                            </em>
                        </h2>
                    </div>
                    <div className="lg:col-span-5 reveal">
                        <p className="text-[15px] md:text-[16px] leading-relaxed text-[var(--uma-text-soft)] font-light">
                            Soluciones contables, fiscales y financieras para
                            empresas y emprendedores de Rocha y todo Uruguay.
                            Trabajamos con un enfoque preventivo: anticipar,
                            asesorar, acompañar.
                        </p>
                    </div>
                </div>

                {/* Bento grid */}
                <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-5">
                    {SERVICES.map((s, i) => {
                        const Icon = s.icon;
                        // Asymmetric spans — first card double width (featured)
                        const spans = [
                            "md:col-span-8",
                            "md:col-span-4",
                            "md:col-span-4",
                            "md:col-span-4",
                            "md:col-span-4",
                            "md:col-span-6",
                            "md:col-span-6",
                            "md:col-span-5",
                            "md:col-span-7",
                        ];
                        return (
                            <div
                                key={i}
                                data-testid={`service-card-${i}`}
                                className={`reveal group ${spans[i]} ${s.featured ? "bg-[var(--uma-forest)] text-[var(--uma-cream)] border-[var(--uma-forest)]" : "bg-white border-[var(--uma-forest)]/8 text-[var(--uma-forest)]"} border rounded-2xl p-6 md:p-7 transition-all hover:-translate-y-1 hover:shadow-[0_14px_40px_-12px_rgba(10,38,20,0.14)] cursor-default relative overflow-hidden`}
                            >
                                {s.featured && (
                                    <div
                                        aria-hidden
                                        className="absolute -right-20 -top-20 w-[280px] h-[280px] rounded-full blur-3xl opacity-30"
                                        style={{
                                            background:
                                                "radial-gradient(circle, #C5A059, transparent 60%)",
                                        }}
                                    />
                                )}
                                <div className="relative flex items-start justify-between mb-7">
                                    <div
                                        className={`w-11 h-11 rounded-xl flex items-center justify-center transition-colors ${
                                            s.featured
                                                ? "bg-[var(--uma-gold)] text-[var(--uma-forest)]"
                                                : "bg-[var(--uma-cream-soft)] text-[var(--uma-forest)] group-hover:bg-[var(--uma-forest)] group-hover:text-[var(--uma-gold)]"
                                        }`}
                                    >
                                        <Icon className="h-5 w-5" strokeWidth={1.5} />
                                    </div>
                                    {s.featured ? (
                                        <span className="text-[10px] uppercase tracking-[0.22em] text-[var(--uma-gold)] font-medium">
                                            Servicio estrella
                                        </span>
                                    ) : (
                                        <span className="text-[10px] uppercase tracking-[0.22em] text-[var(--uma-text-soft)]">
                                            {String(i + 1).padStart(2, "0")}
                                        </span>
                                    )}
                                </div>
                                <h3
                                    className={`relative font-serif-display text-[24px] md:text-[28px] leading-tight ${s.featured ? "text-[var(--uma-cream)]" : "text-[var(--uma-forest)]"}`}
                                >
                                    {s.title}
                                </h3>
                                <p
                                    className={`relative mt-3 text-[14px] leading-relaxed font-light ${s.featured ? "text-[var(--uma-cream)]/70" : "text-[var(--uma-text-soft)]"}`}
                                >
                                    {s.desc}
                                </p>
                            </div>
                        );
                    })}
                </div>

                {/* Agro featured card — único bloque Agro permitido */}
                <div className="mt-5 md:mt-6 reveal">
                    <AgroCard />
                </div>
            </div>
        </section>
    );
}

function AgroCard() {
    return (
        <div
            data-testid="services-agro-card"
            className="relative overflow-hidden rounded-2xl border border-[var(--uma-gold)]/20 bg-[var(--uma-forest)] text-[var(--uma-cream)] p-7 md:p-10 group"
        >
            <div
                aria-hidden
                className="absolute -right-24 -top-24 w-[380px] h-[380px] rounded-full blur-3xl opacity-30"
                style={{
                    background:
                        "radial-gradient(circle, #C5A059, transparent 60%)",
                }}
            />
            <div
                aria-hidden
                className="absolute inset-0 opacity-[0.08] pointer-events-none"
                style={{
                    backgroundImage:
                        "repeating-linear-gradient(90deg, #C5A059 0 1px, transparent 1px 24px)",
                }}
            />

            <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
                <div className="lg:col-span-2 flex lg:flex-col items-center lg:items-start gap-3">
                    <div className="w-14 h-14 rounded-2xl bg-[var(--uma-gold)] text-[var(--uma-forest)] flex items-center justify-center">
                        <Sprout className="h-7 w-7" strokeWidth={1.5} />
                    </div>
                    <div className="lg:mt-3">
                        <div className="text-[10px] uppercase tracking-[0.25em] text-[var(--uma-gold)]">
                            Sector especializado
                        </div>
                        <div className="font-serif-display text-[28px] italic">
                            Agro
                        </div>
                    </div>
                </div>

                <div className="lg:col-span-7">
                    <h3 className="font-serif-display text-[28px] md:text-[36px] leading-tight">
                        ¿Tienes una empresa{" "}
                        <em className="italic text-[var(--uma-gold)]">
                            agropecuaria
                        </em>
                        ?
                    </h3>
                    <p className="mt-3 text-[15px] md:text-[16px] leading-relaxed text-[var(--uma-cream)]/70 font-light max-w-xl">
                        Contamos con un servicio especializado en el sector
                        rural: proyectos de inversión, créditos BROU, COMAP,
                        IMEBA y asesoramiento integral para productores,
                        empresas familiares y cooperativas.
                    </p>
                </div>

                <div className="lg:col-span-3 flex lg:justify-end">
                    <Link
                        to="/agro"
                        data-testid="services-agro-cta"
                        className="group/btn inline-flex items-center gap-2 bg-[var(--uma-gold)] text-[var(--uma-forest)] hover:bg-[var(--uma-cream)] px-6 py-4 rounded-full font-medium transition-all hover:-translate-y-0.5"
                    >
                        Ver servicios Agro
                        <ArrowUpRight className="h-4 w-4 transition-transform group-hover/btn:translate-x-0.5 group-hover/btn:-translate-y-0.5" />
                    </Link>
                </div>
            </div>
        </div>
    );
}
